import { useAtomValue } from 'jotai';
import { MyInfoState } from '@/recoil/atom';
import { useTalkFlowDocumentAiSummary } from '@/hooks/apiHooks';

export type AiPipelineStatus = 'running' | 'success' | 'error';

/**
 * AI 정리(요약) 파이프라인의 "서버 기준" 최신 상태.
 *
 * AI_PIPELINE_RESULT_DETAIL 리스트에서 createdAt 최신 1건의 status 를 읽는다.
 * (배열은 createdAt 오름차순 → 마지막 요소가 최신)
 *
 * 목적: 진행/실패 상태를 SSE 로컬 atom 에만 의존하면 SSE 를 못 받은 다른 기기/새로고침에서
 * ing·error 가 통일되지 않는다. 서버 리스트의 status 를 함께 봐서 로드 시점부터 통일한다.
 *
 * useTalkFlowDocumentAiSummary 는 SWR 캐시를 공유하므로 여러 곳에서 호출해도 추가 요청이 없다.
 */
export default function useLatestAiPipelineStatus(
  docId: string,
): AiPipelineStatus | null {
  const { passportId } = useAtomValue(MyInfoState);
  const { data } = useTalkFlowDocumentAiSummary({
    documentId: docId,
    passportId,
  });

  if (!data || data.length === 0) return null;

  const sorted = [...data].sort((a, b) =>
    a.createdAt.localeCompare(b.createdAt),
  );
  const status = sorted[sorted.length - 1]?.status;

  return status === 'running' || status === 'success' || status === 'error'
    ? status
    : null;
}
